import React, { useState } from 'react';
import MainLayout from '../Layout/MainLayout';
import './Tutorial.css';

const Tutorial = () => {
  const [expandedBanks, setExpandedBanks] = useState({});

  const toggleBank = (bankId) => {
    setExpandedBanks(prev => ({
      ...prev,
      [bankId]: !prev[bankId]
    }));
  };

  const banks = [
    {
      id: 'bb',
      name: 'Banco do Brasil',
      icon: '/icons/bancos/bancodobrasil.png',
      steps: [
        'Acesse sua conta no Internet Banking do Banco do Brasil',
        'No menu, clique em "Conta Corrente" e depois em "Extrato"',
        'Selecione a opção "Conta Corrente" ou "Extrato Mensal / Por Período"',
        'Escolha o período desejado para o extrato',
        'Clique em "Salvar" ou procure um ícone de download e selecione a opção "Money 2000+ (OFX)" ou similar',
        'O arquivo OFX será baixado em seu computador'
      ]
    },
    {
      id: 'itau',
      name: 'Itaú',
      icon: '/icons/bancos/itau.png',
      steps: [
        'Acesse sua conta no Internet Banking do Itaú',
        'Vá para "Conta Corrente"',
        'Em "Saldo e Extrato", clique em "Extrato Detalhado" ou "Consultar extrato por período"',
        'Escolha o período desejado e clique em "Continuar"',
        'Na tela do extrato, procure a opção "Salvar em outros formatos" ou similar',
        'Informe novamente o período (se solicitado) e selecione o formato "OFX / Money 2000"',
        'Clique em "Continuar" ou "Salvar" para baixar o arquivo'
      ]
    },
    {
      id: 'bradesco',
      name: 'Bradesco',
      icon: '/icons/bancos/bradesco.png',
      steps: [
        'Acesse sua conta no Internet Banking do Bradesco',
        'No menu, vá em "Saldos e Extratos"',
        'Selecione a opção "Extrato Mensal / Por Período"',
        'Defina o período desejado e clique em "Buscar"',
        'No canto superior direito da tela do extrato, clique em "Salvar como arquivo" ou em um ícone de exportação',
        'Escolha o formato "OFX (Money 2000 em diante)" ou similar',
        'O download do arquivo será iniciado'
      ]
    },
    {
      id: 'santander',
      name: 'Santander',
      icon: '/icons/bancos/santander.png',
      steps: [
        'Acesse sua conta no Internet Banking do Santander',
        'No menu, procure por "Conta Corrente" e depois "Extrato (Money)" ou similar',
        'Selecione o período desejado para o extrato e clique em "Exibir"',
        'Na tela do extrato, clique em "Exportar"',
        'Marque a opção "Money 2000 ou superior" ou "OFX"',
        'Clique em "Confirmar" para baixar o arquivo'
      ]
    },
    {
      id: 'stone',
      name: 'Stone',
      icon: '/icons/bancos/stone.png',
      steps: [
        'Acesse sua Conta Stone pelo site (conta.stone.com.br) ou pelo aplicativo',
        'No menu, vá em "Extrato"',
        'Clique em "Exportar" ou "Baixar relatório"',
        'Defina o "Tipo de exportação" como "Extrato"',
        'Selecione as datas de início e fim para o período desejado',
        'Escolha "OFX" como o "Formato do arquivo"',
        'Clique em "Baixar" para salvar o arquivo'
      ]
    },
    {
      id: 'sicredi',
      name: 'Sicredi',
      icon: '/icons/bancos/sicredi.png',
      steps: [
        'Acesse sua conta no Internet Banking do Sicredi',
        'No menu, clique em "Extrato"',
        'Escolha o período desejado e clique em "Pesquisar" ou "Consultar"',
        'Após a exibição dos lançamentos, procure e clique no botão "Gerar OFX" ou similar, geralmente localizado na parte inferior da tela',
        'O arquivo OFX será baixado em seu computador'
      ]
    }
  ];

  return (
    <MainLayout>
      <div className="tutorial-container">
        {/* Header */}
        <div className="tutorial-header">
          <h1>Como Usar o Sistema</h1>
          <p>Guia rápido para começar a usar todas as funcionalidades</p>
        </div>

        {/* Process Steps */}
        <div className="process-overview">
          <h2>Processo em 5 Passos</h2>
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">1</div>
              <h3>Extrair OFX</h3>
              <p>Baixe o arquivo OFX do seu banco</p>
            </div>
            <div className="step-card">
              <div className="step-number">2</div>
              <h3>Upload</h3>
              <p>Importe o arquivo no sistema</p>
            </div>
            <div className="step-card">
              <div className="step-number">3</div>
              <h3>Dashboard</h3>
              <p>Visualize dados automáticos</p>
            </div>
            <div className="step-card">
              <div className="step-number">4</div>
              <h3>Categorizar</h3>
              <p>Organize suas transações</p>
            </div>
            <div className="step-card">
              <div className="step-number">5</div>
              <h3>Relatórios</h3>
              <p>Gere análises detalhadas</p>
            </div>
          </div>
        </div>

        {/* Step 1: Extract OFX */}
        <div className="tutorial-section">
          <div className="section-header">
            <div className="section-number">1</div>
            <div className="section-content">
              <h2>Extrair Arquivo OFX do Banco</h2>
              <p>O arquivo OFX contém todas suas transações de forma segura e estruturada.</p>
            </div>
          </div>

          <div className="banks-grid">
            {banks.map((bank) => (
              <div 
                key={bank.id} 
                className={`bank-card ${expandedBanks[bank.id] ? 'expanded' : ''}`}
                onClick={() => toggleBank(bank.id)}
                style={{ cursor: 'pointer' }}
              >
                <div className="bank-header">
                  <div className="bank-info">
                    <img src={bank.icon} alt={bank.name} className="bank-logo" />
                    <span className="bank-name">{bank.name}</span>
                  </div>
                  <div className="expand-icon">
                    <svg 
                      viewBox="0 0 24 24" 
                      width="20" 
                      height="20" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2"
                      style={{ 
                        transform: expandedBanks[bank.id] ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s ease'
                      }}
                    >
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </div>
                </div>
                
                <div className={`bank-content ${expandedBanks[bank.id] ? 'show' : ''}`}>
                  <ol className="bank-steps">
                    {bank.steps.map((step, index) => (
                      <li key={index}>{step}</li>
                    ))}
                  </ol>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Steps 2-5 */}
        <div className="tutorial-section">
          <div className="section-header">
            <div className="section-number">2-5</div>
            <div className="section-content">
              <h2>Do Upload aos Relatórios</h2>
              <p>Processo automatizado após o upload do arquivo</p>
            </div>
          </div>

          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-marker">2</div>
              <div className="timeline-content">
                <h3>📤 Upload no Sistema</h3>
                <p>Vá em "Gerenciador de Períodos" e faça upload do arquivo OFX.</p>
                <ul>
                  <li>Sistema extrai automaticamente todas as receitas e despesas</li>
                  <li>Calcula resultado líquido (lucro/prejuízo)</li>
                  <li>Organiza tudo cronologicamente</li>
                </ul>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-marker">3</div>
              <div className="timeline-content">
                <h3>📊 Dashboard Automático</h3>
                <p>Visualização instantânea dos seus dados financeiros.</p>
                <ul>
                  <li>Cards com receitas, despesas e resultado</li>
                  <li>Gráficos de evolução mensal</li>
                  <li>Indicadores de performance</li>
                </ul>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-marker">4</div>
              <div className="timeline-content">
                <h3>🏷️ Categorização</h3>
                <p>Vá em "Itens não Categorizados" e organize fornecedores por categoria uma única vez.</p>
                <ul>
                  <li>Associe fornecedores às categorias DRE</li>
                  <li>Sistema aprende e categoriza automaticamente</li>
                  <li>Aplicado retroativamente a todas as transações</li>
                </ul>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-marker">5</div>
              <div className="timeline-content">
                <h3>📈 Relatórios Detalhados</h3>
                <p>Análises profissionais para tomada de decisão.</p>
                <ul>
                  <li>Relatório DRE completo</li>
                  <li>Gastos por categoria com percentuais</li>
                  <li>Comparações entre períodos</li>
                  <li>Exportação em PDF</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </MainLayout>
  );
};

export default Tutorial;